// Match Blockly's classroom-number policy without discarding unresolved records.
export function hasVerifiedRobotNumber(robot) {
  return !!robot && robot.numberVerified !== false &&
    Number.isSafeInteger(robot.identifier) && robot.identifier >= 0;
}

export function getStudentRobotLabel(robotOptions, robotId) {
  const robot = Object.values(robotOptions).find(option => option._id === robotId);
  return hasVerifiedRobotNumber(robot) ? String(robot.identifier) : '---';
}
